import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import image1 from "../../assets/images/Industry/Automotive & Auto Components.png"
import image2 from "../../assets/images/Industry/Banking, Financial Services & Insurance (BFSI).png"
import image3 from "../../assets/images/Industry/BPO, KPO & Shared Services.png"
import image4 from "../../assets/images/Industry/Construction & Infrastructure.png"
import image5 from "../../assets/images/Industry/Digital Marketing & Creative Agencies.png"
import image6 from "../../assets/images/Industry/Education & EdTech.png"
import image7 from "../../assets/images/Industry/Electronics & Semiconductor.png"
import image8 from "../../assets/images/Industry/Energy, Power & Utilities.png"
import image9 from "../../assets/images/Industry/FMCG & Consumer Goods.png"
import image10 from "../../assets/images/Industry/Food & Beverage.png"
import image11 from "../../assets/images/Industry/Healthcare & Pharmaceuticals.png"
import image12 from "../../assets/images/Industry/Hospitality & Tourism.png"
import image13 from "../../assets/images/Industry/Hospitals & Medical Devices.png"
import image14 from "../../assets/images/Industry/Information Technology (IT) & Software.png"
import image15 from "../../assets/images/Industry/Logistics, Supply Chain & Warehousing.png"
import image16 from "../../assets/images/Industry/Manufacturing & Engineering.png"
import image17 from "../../assets/images/Industry/Media, Entertainment & Advertising.png"
import image18 from "../../assets/images/Industry/Oil & Gas.png"
import image19 from "../../assets/images/Industry/Real Estate & Property Management.png"
import image20 from "../../assets/images/Industry/Renewable Energy.png"
import image21 from "../../assets/images/Industry/Retail & E-commerce.png"
import image22 from "../../assets/images/Industry/Startups & Emerging Businesses.png"
import image23 from "../../assets/images/Industry/Telecommunications.png"
import image24 from "../../assets/images/Industry/Textile, Apparel & Fashion.png"
import image25 from "../../assets/images/Industry/Trading & Distribution.png"
import image26 from "../../assets/images/Industry/Transportation & Mobility.png"

const industrySectors = [
    {
        name: "Automotive & Auto Components",
        image: image1,
    },
    {
        name: "Banking, Financial Services & Insurance",
        image: image2,
    },
    {
        name: "BPO, KPO & Shared Services",
        image: image3,
    },
    {
        name: "Construction & Infrastructure",
        image: image4,
    },
    {
        name: "Digital Marketing & Creative Agencies",
        image: image5,
    },
    {
        name: "Information Technology (IT) & Software",
        image: image6,
    },
    {
        name: "Electronics & Semiconductor",
        image: image7,
    },
    {
        name: "Energy, Power & Utilities",
        image: image8,
    },
    {
        name: "Media, Entertainment & Advertising",
        image: image9,
    },
    {
        name: "Food & Beverage",
        image: image10,
    },
    {
        name: "Healthcare & Pharmaceuticals",
        image: image11,
    },
    {
        name: "Hospitality & Tourism",
        image: image12,
    },
    {
        name: "Hospitals & Medical Devices",
        image: image13,
    },
    {
        name: "Information Technology (IT) & Software",
        image: image14,
    },
    {
        name: "Logistics, Supply Chain & Warehousing",
        image: image15,
    },
    {
        name: "Manufacturing & Engineering",
        image: image16,
    },
    {
        name: "Media, Entertainment & Advertising",
        image: image17,
    },
    {
        name: "Oil & Gas",
        image: image18,
    },
    {
        name: "Real Estate & Property Management",
        image: image19,
    },
    {
        name: "Renewable Energy",
        image: image20,
    },
    {
        name: "Retail & E-commerce",
        image: image21,
    },
    {
        name: "Startups & Emerging Businesses",
        image: image22,
    },
    {
        name: "Telecommunications",
        image: image23,
    },
    {
        name: "Textile, Apparel & Fashion",
        image: image24,
    },
    {
        name: "Trading & Distribution",
        image: image25,
    },
    {
        name: "Transportation & Mobility",
        image: image26,
    },

];



const TeamMemberCard = ({ name, position, image }) => (
    <div className="single-team-item-three mb-40 wow fadeInDown">
        <div className="img-holder">
            <img src={image} alt="Member Image" />
        </div>
        <div className="text text-center service-sector-title">
            <h3 className="title">{name}</h3>
            <p className="position">{position}</p>
        </div>
    </div>
);

export const ServiceSectors = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
    };

    return (
        <div>
            <section className="team-section bg-color-three pt-50 pb-60">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-10">
                            <div className="section-title text-center mb-60 wow fadeInDown">
                                <span className="sub-title">Industries</span>
                                <h4>Industries We Provide Services</h4>
                            </div>
                        </div>
                    </div>

                    {/* Grid display for larger screens */}
                    <div className="row d-none d-md-flex">
                        {industrySectors.map((sector, index) => (
                            <div className="col-xl-3 col-md-6 col-sm-12" key={index}>
                                <TeamMemberCard
                                    name={sector.name}
                                    position={sector.position}
                                    image={sector.image}
                                />
                            </div>
                        ))}
                    </div>

                    {/* Slider display for mobile devices */}
                    <div className="d-md-none">
                        <Slider {...settings}>
                            {industrySectors.map((member, index) => (
                                <div key={index}>
                                    <TeamMemberCard
                                        name={member.name}
                                        position={member.position}
                                        image={member.image}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </section>
        </div>
    );
};


export default ServiceSectors;